module.exports = __webpack_public_path__ + "img/PGR_A04_back_en.3a420c19.png";